<fgb-mobile-page-header [pageTitle]="'faq.page.title'" backButtonLink="/" [showBalance]="false" [showQr]="false" />
<fgb-banner class="d-lg-block d-none" [title]="'faq.page.title' | translate" />

<div class="container mobile-container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
